import { MESSAGE_TYPE, WIZARD_EVENT_KIND, HANDSHAKE_START_EVENT } from '../constants.js';

const isHandshakeEvent = (event) => {
  const data = event.data || {};
  const { type, kind, eventName } = data;
  return type === MESSAGE_TYPE && kind === WIZARD_EVENT_KIND && eventName === HANDSHAKE_START_EVENT;
};

export { isHandshakeEvent };
